import { arrayOf, func } from 'prop-types';
import React from 'react';
import Select from 'react-select';

import { quoteLineBundleShape } from '../../prop-types';

function QuoteLineBundleSelection({ bundles, onSelect }) {
  const options = bundles.map(({ id, name }) => ({ label: name, value: id }));

  function handleSelect({ value }) {
    const bundle = bundles.find(({ id }) => id === value);
    onSelect(bundle);
  }

  return (
    <Select
      options={options}
      onChange={handleSelect}
      placeholder="Add bundle…"
    />
  );
}

QuoteLineBundleSelection.propTypes = {
  bundles: arrayOf(quoteLineBundleShape.isRequired).isRequired,
  onSelect: func.isRequired,
};

export default QuoteLineBundleSelection;
